import { useQuery } from "react-query";

import { TariffsService } from "~/entity/Tariffs/api/tariffsService";
import { IBaseTariffDetailApi } from "~/entity/Tariffs/model/schema";

export const useGetBaseTariff = (id?: string | null) => {
  const query = useQuery({
    queryKey: [TariffsService._routes.root, "base-tariff", id],
    queryFn: () => TariffsService.GET.byId(id as string),
    enabled: !!id,
  });

  return {
    ...query,
    tariff: query.data?.data?.tariff as IBaseTariffDetailApi | undefined,
  };
};
